import {
  Circle2,
  CircularProgress2,
  Timer2Background,
  Timer2Blind,
  Timer2BlindWrapper,
  Timer2InfoWrapper,
  Timer2LeftItemWrapper,
  Timer2LeftWrapper,
  Timer2NextBlind,
  Timer2Notice,
  Timer2PrizeItem,
  Timer2PrizeItemTop3,
  Timer2PrizeListWrapper,
  Timer2PrizeWrapper,
  Timer2TimerBox,
  Timer2TimeWrapper,
  UserTimeWrapper2,
} from "./styles/vertical";
import { calculatePercentage, formatNumber } from "../../../utils/timer";
import AdVideo from "../../../component/AdVideo";
import VerticalTimerPrizeBox from "../component/vertical-prize-box";
import { useClock } from "../hooks/use-clock";
import { Helmet } from "react-helmet";

const UserVerticalTimer3 = () => {
  const radius = 491;
  const circumference = 2 * Math.PI * radius;

  const {
    timeInfo,
    userCount,
    reBuyInUserCount,
    entryUserCount,
    adOnUserCount,
    stack,
    avgStack,
    pub,
    coverImage,
    backgroundImage,
    isAd,
    setIsAd,
    data,
    visibleRanks,
    getNextBlind,
    getNowBlind,
    getData,
    subPrizeFont,
  } = useClock();

  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <UserTimeWrapper2>
        {backgroundImage && (
          <Timer2Background backgroundImage={backgroundImage} />
        )}
        <Timer2TimeWrapper>
          <Circle2
            break={
              timeInfo.currentLevel?.type === "BREAK" &&
              timeInfo.elapsedTimeMs &&
              timeInfo.elapsedTimeMs > 0
                ? true
                : false
            }
          >
            <circle className="background" r={492} cx="506" cy="506" />
            <circle
              className="progress"
              r={492}
              cx="506"
              cy="506"
              strokeDasharray={circumference}
              strokeDashoffset={
                timeInfo.currentLevel &&
                timeInfo.remainingTimeInCurrentLevelMs &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? circumference -
                    (timeInfo.remainingTimeInCurrentLevelMs /
                      (timeInfo.currentLevel?.time * 60000)) *
                      circumference
                  : 0
              }
            />
          </Circle2>
          <div className="dash-wrapper">
            <img
              src={
                timeInfo.currentLevel?.type === "LEVEL" &&
                timeInfo.elapsedTimeMs &&
                timeInfo.elapsedTimeMs > 0
                  ? "/image-web/timer/dash-progress.png"
                  : "/image-web/timer/break-dash-progress.png"
              }
              alt="dash"
            />
            <CircularProgress2
              progress={
                timeInfo.currentLevel && timeInfo.remainingTimeInCurrentLevelMs
                  ? calculatePercentage(
                      timeInfo.remainingTimeInCurrentLevelMs,
                      timeInfo.currentLevel?.time * 60000,
                    ) - 0.4
                  : 0
              }
            />
          </div>
          <Timer2TimerBox>
            <div className="title-box">
              <div className="pub-name">{pub?.cafeName}</div>
              <div className="header">
                {coverImage && <img src={coverImage} alt="logo" />}
                <div className="info-row">
                  <div className="title">{data?.title}</div>
                  <div className="type">{data?.subTitle}</div>
                </div>
              </div>
            </div>
            <div className="level-break">
              <div
                className={`now-level ${
                  timeInfo.currentLevel?.type === "BREAK" && "break "
                }`}
              >{`${
                timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs > 0
                  ? timeInfo.currentLevel?.type === "LEVEL"
                    ? "현재 " + timeInfo.currentLevel.level + "LV"
                    : "BREAK"
                  : "시작 준비중"
              }`}</div>
            </div>
            <div
              className={`time ${
                timeInfo.currentLevel?.type === "LEVEL" &&
                timeInfo?.elapsedTimeMs &&
                timeInfo?.elapsedTimeMs > 0 &&
                "level "
              }`}
            >
              {timeInfo.remainingTimeInCurrentLevel}
            </div>
          </Timer2TimerBox>
          <Timer2BlindWrapper>
            <Timer2Blind>
              <div className="title">NOW BLINDS</div>
              <div className="value">
                <div className="blind">{getNowBlind()}</div>
              </div>
            </Timer2Blind>
            <Timer2NextBlind>
              <div className="title next">NEXT BLINDS</div>
              <div className="value">
                <div className="blind next">{getNextBlind()}</div>
              </div>
            </Timer2NextBlind>
          </Timer2BlindWrapper>
        </Timer2TimeWrapper>
        <Timer2InfoWrapper>
          <Timer2LeftWrapper>
            <Timer2LeftItemWrapper>
              <div className="title">PLAYERS</div>
              <div className="value">{`${userCount} / ${
                adOnUserCount + reBuyInUserCount + entryUserCount
              }`}</div>
            </Timer2LeftItemWrapper>
            <Timer2LeftItemWrapper>
              <div className="title">TOTAL TIME</div>
              <div className="value">{timeInfo.elapsedTime}</div>
            </Timer2LeftItemWrapper>
            <Timer2LeftItemWrapper>
              <div className="title">TOTAL STACKS</div>
              <div className="value">{formatNumber(stack)}</div>
            </Timer2LeftItemWrapper>
            <Timer2LeftItemWrapper>
              <div className="title">AVG STACKS</div>
              <div className="value">{formatNumber(avgStack)}</div>
            </Timer2LeftItemWrapper>
            <Timer2LeftItemWrapper>
              <div className="title">NEXT BREAK</div>
              <div className="value">{timeInfo.timeUntilNextBreak}</div>
            </Timer2LeftItemWrapper>
          </Timer2LeftWrapper>
          <Timer2PrizeWrapper>
            <Timer2PrizeListWrapper>
              <div className="title">PRIZE POOL</div>
              <div className="list-wrapper">
                {data?.moneyInChip.map((item: any, index: number) =>
                  index < 3 ? (
                    <Timer2PrizeItemTop3>
                      <div className={`rank`}>{`${index + 1}${
                        index === 0
                          ? "st"
                          : index === 1
                            ? "nd"
                            : index === 2
                              ? "rd"
                              : "th"
                      }`}</div>
                      <VerticalTimerPrizeBox
                        data={data}
                        item={item}
                        index={index}
                        subPrizeFont={subPrizeFont}
                      />
                    </Timer2PrizeItemTop3>
                  ) : (
                    visibleRanks.includes(index + 1) && (
                      <Timer2PrizeItem length={data?.moneyInChip.length}>
                        <div className={`rank`}>{`${index + 1}${
                          index === 0
                            ? "st"
                            : index === 1
                              ? "nd"
                              : index === 2
                                ? "rd"
                                : "th"
                        }`}</div>
                        <VerticalTimerPrizeBox
                          data={data}
                          item={item}
                          index={index}
                          subPrizeFont={subPrizeFont}
                        />
                      </Timer2PrizeItem>
                    )
                  ),
                )}
              </div>
            </Timer2PrizeListWrapper>
            <Timer2Notice
              dangerouslySetInnerHTML={{
                __html: data?.notice
                  ? data.notice.replace(/\n/g, "<br />")
                  : "",
              }}
            />
          </Timer2PrizeWrapper>
        </Timer2InfoWrapper>
        {isAd && (
          <AdVideo
            coverImage={coverImage}
            onClose={() => setIsAd(false)}
            data={data}
            timeInfo={timeInfo}
            stack={stack}
            avgStack={avgStack}
          />
        )}
      </UserTimeWrapper2>
    </>
  );
};
export default UserVerticalTimer3;
